module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<tr>\n  <td>{{row.agreement_performer_name}}</td>\n  <td>{{row.agreement_number}}</td>\n  <td>{{row.expense_description}}</td>\n  <td>{{row.expense_document_number}}</td>\n  <td>{{row.expense_document_date}}</td>\n  <td>{{row.payment_date}}</td>\n  <td>{{row.payment_document_number}}</td>\n  <td>{{row.total_amount}}</td>\n  <td>{{row.applicable_amount}}</td>\n  <td>\n    {{expense_type}}\n  </td>\n  <td>\n    <div class='form-group'>\n      <textarea class='form-control' cols='" + ($e($c(30))) + "' name='client_notes' v-model='row.client_notes'></textarea>\n    </div>\n  </td>\n</tr>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
